import {Fragment, useEffect, useState} from 'react';
import {Link} from 'react-router';

import {removeMenuTitle} from '@/lib/helpers';

import {ADMINMENUITEMS} from '../sidebar/sidemenu/sidemenu';

const Modalsearch = () => {
  //Search functionality
  const [_show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  const [show1, setShow1] = useState(false);
  const [InputValue, setInputValue] = useState('');
  const [show2, setShow2] = useState(false);
  const [searchcolor, setsearchcolor] = useState('text-dark');
  const [searchval, setsearchval] = useState('Type something');
  const [NavData, setNavData] = useState([]);
  useEffect(() => {
    const clickHandler = (_event: any) => {
      const searchResult = document.querySelector('.search-result');
      if (searchResult) {
        searchResult.classList.add('hidden');
      }
    };

    document.addEventListener('click', clickHandler);

    return () => {
      // Clean up the event listener when the component unmounts
      document.removeEventListener('click', clickHandler);
    };
  }, []);

  document.addEventListener('click', function () {
    document.querySelector('.search-result')?.classList.add('d-none');
  });

  const myfunction = (inputvalue: any) => {
    document.querySelector('.search-result')?.classList.remove('d-none');

    const i: any = [];
    const allElement2: any = [];

    removeMenuTitle(ADMINMENUITEMS).forEach(mainLevel => {
      if (mainLevel.children) {
        setShow1(true);
        mainLevel.children.forEach(subLevel => {
          i.push(subLevel);
          if (subLevel.children) {
            subLevel.children.forEach((subLevel1: any) => {
              i.push(subLevel1);
              if (subLevel1.children) {
                subLevel1.children.forEach((subLevel2: any) => {
                  i.push(subLevel2);
                });
              }
            });
          }
        });
      }
    });

    for (const allElement of i) {
      if (allElement.title.toLowerCase().includes(inputvalue.toLowerCase())) {
        if (allElement.title.toLowerCase().startsWith(inputvalue.toLowerCase())) {
          setShow2(true);

          // Check if the element has a path and doesn't already exist in allElement2 before pushing
          if (allElement.path && !allElement2.some((el: any) => el.title === allElement.title)) {
            allElement2.push(allElement);
          }
        }
      }
    }

    if (!allElement2.length || inputvalue === '') {
      if (inputvalue === '') {
        setShow2(false);
        setsearchval('Type something');
        setsearchcolor('text-dark');
      }
      if (!allElement2.length) {
        setShow2(false);
        setsearchcolor('text-danger');
        setsearchval('There is no component with this name');
      }
    }

    setNavData(allElement2);
  };

  const Removingdata = [
    {id: 1, name: 'People'},
    {id: 2, name: 'Pages'},
    {id: 3, name: 'Articles'},
    {id: 4, name: 'Tags'},
  ];
  const [items, setItems] = useState(Removingdata);

  const handleRemove = (index: number) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  return (
    <Fragment>
      <div id="search-modal" className="hs-overlay ti-modal mt-[1.75rem] hidden" onClick={handleClose}>
        <div className="ti-modal-box">
          <div className="ti-modal-content !rounded-[0.5rem] !border !border-defaultborder dark:!border-defaultborder/10">
            <div className="ti-modal-body">
              <div className="input-group flex w-full rounded-[0.25rem] border-[2px] border-primary">
                <a
                  aria-label="anchor"
                  href="#!"
                  className="input-group-text flex items-center !rounded-none border-e-[#dee2e6] bg-light !px-[0.75rem] !py-[0.375rem] !text-[0.875rem]"
                  id="Search-Grid"
                >
                  <i className="fe fe-search header-link-icon text-[0.875rem]"></i>
                </a>

                <input
                  type="search"
                  className="form-control w-full border-0 px-2 !text-[0.8rem] focus:ring-transparent"
                  placeholder="Search"
                  aria-label="Username"
                  defaultValue={InputValue}
                  autoComplete="off"
                  onChange={ele => {
                    myfunction(ele.target.value);
                    setInputValue(ele.target.value);
                  }}
                />

                <a
                  aria-label="anchor"
                  href="#!"
                  className="input-group-text flex items-center bg-light !px-[0.75rem] !py-[0.375rem]"
                  id="voice-search"
                >
                  <i className="fe fe-mic header-link-icon"></i>
                </a>
                <div className="hs-dropdown ti-dropdown">
                  <a
                    aria-label="anchor"
                    href="#!"
                    className="hs-dropdown-toggle ti-dropdown-toggle btn btn-light btn-icon flex h-[2.413rem] w-[2.313rem] items-center !rounded-none !bg-light !px-[0.75rem] !py-[0.375rem] text-[0.95rem]"
                  >
                    <i className="fe fe-more-vertical"></i>
                  </a>
                  <ul className="hs-dropdown-menu ti-dropdown-menu absolute !-mt-2 hidden !p-0">
                    <li>
                      <a
                        className="ti-dropdown-item flex !px-[0.9375rem] !py-[0.5rem] !text-[0.8125rem] font-medium text-defaulttextcolor dark:text-defaulttextcolor/70"
                        href="#!"
                      >
                        Action
                      </a>
                    </li>
                    <li>
                      <a
                        className="ti-dropdown-item flex !px-[0.9375rem] !py-[0.5rem] !text-[0.8125rem] font-medium text-defaulttextcolor dark:text-defaulttextcolor/70"
                        href="#!"
                      >
                        Another action
                      </a>
                    </li>
                    <li>
                      <a
                        className="ti-dropdown-item flex !px-[0.9375rem] !py-[0.5rem] !text-[0.8125rem] font-medium text-defaulttextcolor dark:text-defaulttextcolor/70"
                        href="#!"
                      >
                        Something else here
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a
                        className="ti-dropdown-item flex !px-[0.9375rem] !py-[0.5rem] !text-[0.8125rem] font-medium text-defaulttextcolor dark:text-defaulttextcolor/70"
                        href="#!"
                      >
                        Separated link
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {show1 ? (
                <div className="box search-result search-fix w-100 relative z-[9] mt-1 border border-gray-200 dark:border-white/10">
                  <div className="box-header">
                    <h6 className="box-title text-break me-2">Search result of {InputValue}</h6>
                  </div>
                  <div className="box-body flex max-h-[250px] flex-col overflow-auto p-2">
                    {show2 ? (
                      NavData.map((e: any) => (
                        <div
                          key={Math.random()}
                          className="ti-list-group dark:bg-bgdark gap-x-3.5 text-gray-800 dark:border-white/10 dark:text-white"
                        >
                          <Link
                            to={`${e.path}/`}
                            className="search-result-item"
                            onClick={() => {
                              setShow1(false);
                              setInputValue('');
                            }}
                          >
                            {e.title}
                          </Link>
                        </div>
                      ))
                    ) : (
                      <b className={`${searchcolor} `}>{searchval}</b>
                    )}
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className="mt-5">
                <p className="mb-2 text-[0.813rem] font-normal text-[#8c9097] dark:text-gray-200 dark:text-white/50">
                  Are You Looking For...
                </p>

                {items.map((idx, index) => (
                  <span
                    className="search-tags me-1 !px-[0.55rem] !py-[0rem] text-[0.75rem] dark:border-defaultborder/10"
                    key={index}
                  >
                    <i className="fe fe-user me-2"></i>
                    {idx.name}
                    <a href="#!" className="tag-addon header-remove-btn" onClick={() => handleRemove(index)}>
                      <span className="sr-only">Remove badge</span>
                      <i className="fe fe-x"></i>
                    </a>
                  </span>
                ))}
              </div>

              <div className="my-[1.5rem]">
                <p className="mb-2 text-[0.813rem] font-normal text-[#8c9097] dark:text-white/50">Recent Search :</p>

                <div
                  id="dismiss-alert"
                  role="alert"
                  className="alert !mb-2 flex items-center rounded-[0.3125rem] border !p-2 !text-[0.8125rem] text-defaulttextcolor dark:border-defaultborder/10 dark:text-defaulttextcolor/70"
                >
                  <Link to={`${import.meta.env.BASE_URL}pages/notifications`}>
                    <span>Notifications</span>
                  </Link>
                  <Link
                    aria-label="anchor"
                    className="ms-auto leading-none"
                    to="#"
                    data-hs-remove-element="#dismiss-alert"
                  >
                    <i className="fe fe-x !text-[0.8125rem] text-[#8c9097] dark:text-white/50"></i>
                  </Link>
                </div>

                <div
                  id="dismiss-alert1"
                  role="alert"
                  className="alert !mb-2 flex items-center rounded-[0.3125rem] border !p-2 !text-[0.8125rem] text-defaulttextcolor dark:border-defaultborder/10 dark:text-defaulttextcolor/70"
                >
                  <Link to={`${import.meta.env.BASE_URL}uielements/alerts`}>
                    <span>Alerts</span>
                  </Link>
                  <Link
                    aria-label="anchor"
                    className="ms-auto leading-none"
                    to="#"
                    data-hs-remove-element="#dismiss-alert1"
                  >
                    <i className="fe fe-x !text-[0.8125rem] text-[#8c9097] dark:text-white/50"></i>
                  </Link>
                </div>

                <div
                  id="dismiss-alert2"
                  role="alert"
                  className="alert !mb-0 flex items-center rounded-[0.3125rem] border !p-2 !text-[0.8125rem] text-defaulttextcolor dark:border-defaultborder/10 dark:text-defaulttextcolor/70"
                >
                  <Link to={`${import.meta.env.BASE_URL}pages/email/mailapp`}>
                    <span>Mail</span>
                  </Link>
                  <Link aria-label="anchor" className="lh-1 ms-auto" to="#" data-hs-remove-element="#dismiss-alert2">
                    <i className="fe fe-x !text-[0.8125rem] text-[#8c9097] dark:text-white/50"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="ti-modal-footer !px-[1.25rem] !py-[1rem]">
              <div className="inline-flex rounded-md shadow-sm">
                <button
                  type="button"
                  className="ti-btn-group ti-btn-primary !rounded-e-none rounded-s-[0.25rem] !px-[0.75rem] !py-[0.45rem] !text-[0.75rem] dark:border-white/10"
                >
                  Search
                </button>
                <button
                  type="button"
                  className="ti-btn-group ti-btn-primary-full !rounded-s-none rounded-e-[0.25rem] !px-[0.75rem] !py-[0.45rem] !text-[0.75rem] dark:border-white/10"
                >
                  Clear Recents
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Modalsearch;
